import script from "./fenxi.vue?vue&type=script&setup=true&lang=js"
export * from "./fenxi.vue?vue&type=script&setup=true&lang=js"

import "./fenxi.vue?vue&type=style&index=0&id=389e2d4a&lang=scss"

const __exports__ = script;

export default __exports__